import { Loader2 } from 'lucide-react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="flex justify-center">
          <img
            src="/glooci_logo.png"
            alt="Glooci"
            className="h-16 w-auto animate-bounce-gentle"
          />
        </div>
        <div className="flex items-center justify-center space-x-2">
          <Loader2 size={24} className="animate-spin text-primary" />
          <span className="text-text-secondary">Caricamento...</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
